import React from 'react';
import cn from 'classnames';
import { Button, type ButtonProps } from '@direct-frontend/components';
import styles from './PickupAddressFiltersButton.module.css';

type PickupAddressFiltersButton = Omit<ButtonProps, 'color' | 'size'> & {
    isChecked?: boolean;
};

export const PickupAddressFiltersButton: React.FC<PickupAddressFiltersButton> = ({
    children,
    className,
    isChecked,
    ...other
}) => (
    <Button className={cn(className, { [styles.checked]: isChecked })} color="contour" size="s" {...other}>
        {children}
    </Button>
);
